import Icon from "../Icon"

export const getNameShortForm = contact => {
    const strHandle = str =>
        str
            .trim()
            .split(" ")
            .reduce((acc, v, i, arr) => {
                if (i === 0) {
                    acc += v.charAt(0).toUpperCase()
                }

                if (i === arr.length - 1) {
                    acc += v.charAt(0).toUpperCase()
                }
                return acc
            }, "") || "CL"

    if (typeof contact === "string") {
        return strHandle(contact)
    } else if (typeof contact === "object") {
        if (contact?.name) {
            return strHandle(contact.name)
        } else if (contact?.fullname) {
            return strHandle(contact.fullname)
        } else if (contact.firstname && contact.lastname) {
            return `${contact.firstname.substring(0, 1)}${contact.lastname.substring(0, 1)}`.trim()
        }
    }
    return "CL"
}

export const ContactName = ({ contact, onClick }) => {
    const { firstname, lastname, vendorcontactid } = contact || {}

    if (!firstname && !lastname) {
        return <></>
    }

    if (!onClick) {
        return (
            <div className="stg-softphone-contact-name">
                {firstname} {lastname}
            </div>
        )
    }

    return (
        <div
            className="stg-softphone-contact-link"
            onClick={() => onClick(vendorcontactid)}
            onMouseDown={e => e.stopPropagation()}>
            <div className="stg-softphone-contact-name">
                {firstname} {lastname}{" "}
            </div>
            <Icon icon="fa-external-link-alt" />
        </div>
    )
}
